import { useFormContext } from "react-hook-form";
import { ContractOrderRequest } from "forms/RequestOrderForm";

export type RequestOrderFormSelectedOptions = {
  mode: SelectOption | null;
  shipFrom: SelectOption | null;
  salesTerms: SelectOption | null;
  shipTo: SelectOption | null;
};

const useWatchRequestOrderFormSelectOptions =
  (): RequestOrderFormSelectedOptions => {
    const { watch } = useFormContext<ContractOrderRequest>();
    const [shipTo, shipFrom, salesTerms, mode] = watch([
      "shipTo",
      "shipFrom",
      "salesTerms",
      "mode",
    ]);

    return {
      shipTo,
      shipFrom,
      salesTerms,
      mode,
    };
  };

export default useWatchRequestOrderFormSelectOptions;
